// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__1x0Jz"};